import { gql } from "@apollo/client"

export const EMAILQUERY=gql
`mutation  EmailValidation($mails: [String!]) {
  emailValidation(mails: $mails) {
    email
    code
    role
    free_email
    result
    reason
    send_transactional
    did_you_mean
    verifiedAt
    isStale
  }
}`

export const UPDATE_CONTACT_VERIFICATION = gql`
  mutation UpdateContactVerification(
    $leadId: String!
    $email: String!
    $status: Boolean
    $verifiedAt: String
    $verifyResult: String
    $verifyCode: String
    $verifyReason: String
  ) {
    updateContactVerification(
      leadId: $leadId
      email: $email
      status: $status
      verifiedAt: $verifiedAt
      verifyResult: $verifyResult
      verifyCode: $verifyCode
      verifyReason: $verifyReason
    )
  }
`;

export const RE_VERIFY_EMAIL = gql`
  mutation ReVerifyEmail($email: String!) {
    reVerifyEmail(email: $email) {
      email
      code
      role
      free_email
      result
      reason
      send_transactional
      did_you_mean
      verifiedAt
      isStale
    }
  }
`;

